function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { UserService } from "./Services/UserService";
import { OAuthService } from './Services/OAuthService';
export var MppAboutMe = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppAboutMe, _ComponentBase);

  var _super = _createSuper(MppAboutMe);

  function MppAboutMe() {
    var _this;

    _classCallCheck(this, MppAboutMe);

    _this = _super.call(this);
    _this.userLoggedIn = false;
    return _this;
  }

  _createClass(MppAboutMe, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {}
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.LoadLabels();

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; // Root html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mpp-about-me--content-container" id="widgetContentContainer" style="display: none"><div class="mpp-about-me--header-container"><h2 class="mpp-about-me--header">${i18n.title}</h2><h2 class="mpp-about-me--header-subtitle">${i18n.subtitle}</h2><div class="mpp-about-me--edit-button" style="display: none;" id="editMySkills"><img class="mpp-about-me--edit-attributes-icon" src="${this._appRoot}/Content/icons/icon-edit.svg"/> <span class="mpp-about-me--edit-button-text">${i18n.editButton}</span></div></div><div class="mpp-about-me--notification-container" style="display: none"><div class="mpp-about-me--notification-text"></div><div class="mpp-about-me--notification-close"><img class="mpp-about-me--close-notification-icon" src="${this._appRoot}/Content/icons/icon-close-white.svg"/></div></div><div class="mpp-about-me--view-attributes-container" id="userAttributesViewMode" style="display:none"></div><div class="mpp-about-me--edit-attributes-container" id="userAttributesEditModeContainer" style="display:none"><div id="userAttributesEditMode"></div><div class="mpp-about-me--edit-buttons"><div class="mpp-about-me--submit-button" id="submitAttributes">${i18n.submitButton}</div><div class="mpp-about-me--cancel-button" id="cancelEditAttributes">${i18n.cancelButton}</div></div></div></div><div id="loadingContainer" class="mpp-about-me--centered"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none"></div></div>` ; //Selectors

                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer"); //Templates

                this._$loginButtonContainer.innerHTML +=  `<div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${i18n.loginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="${i18n.loginButton}"/>` ;
                this._$loadingContainer.innerHTML +=  `<i class="mppw-spinner"></i>` ;
                this.BindHtmlElements();
                this.BindEventListeners(); // Try logging in user

                _context.next = 13;
                return this.TryLoginUser();

              case 13:
                if (this.userLoggedIn) {
                  this.DisplayAttributes();
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "DisplayAttributes",
    value: function () {
      var _DisplayAttributes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.FetchAndGroupAttributes();

              case 2:
                this._userGroupedAttributes = _context2.sent;

                if (this._userGroupedAttributes.length <= 0) {
                  this._allGroupedAttributes = this.MergeAndGroupAllAttributes();
                  this.DrawAttributesEditMode();
                } else {
                  this.DrawAttributesViewMode();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function DisplayAttributes() {
        return _DisplayAttributes.apply(this, arguments);
      }

      return DisplayAttributes;
    }()
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        UserService.GetCurrentUser().then(function (userInfo) {
          if (!!userInfo) {
            _this2.userLoggedIn = true;
            _this2._$loginButtonContainer.style.display = "none";
            _this2._$widgetContent.style.display = "";
          } else {
            _this2._$loginButtonContainer.style.display = "";
            _this2._$widgetContent.style.display = "none";
          }

          _this2._$loadingContainer.style.display = "none";
          resolve();
        }, function () {
          _this2._$loadingContainer.style.display = "none";
          _this2._$widgetContent.style.display = "none";
          _this2._$loginButtonContainer.style.display = "";
          resolve();
        });
      });
    }
  }, {
    key: "FetchAndGroupAttributes",
    value: function () {
      var _FetchAndGroupAttributes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var allAttributes, userAttributes, groupedAttributes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return UserService.GetAllActiveAttributes();

              case 2:
                allAttributes = _context3.sent;
                _context3.next = 5;
                return UserService.GetCurrentUserAttributes();

              case 5:
                userAttributes = _context3.sent;
                this._userAttributes = userAttributes;
                this._allActiveAttributes = allAttributes;
                groupedAttributes = [];
                userAttributes.forEach(function (attr) {
                  var attribute = _this3._allActiveAttributes.find(function (x) {
                    return x.attributeId === attr.attributeId;
                  });

                  if (attribute) {
                    var group = groupedAttributes.find(function (x) {
                      return x.attributeTypeId === attribute.attributeTypeId;
                    });

                    if (group) {
                      group.attributes.push({
                        attributeId: attribute.attributeId,
                        attributeName: attribute.attributeName
                      });
                    } else {
                      groupedAttributes.push({
                        attributeTypeId: attribute.attributeTypeId,
                        attributeTypeName: attribute.attributeTypeName,
                        attributes: [{
                          attributeId: attribute.attributeId,
                          attributeName: attribute.attributeName
                        }]
                      });
                    }
                  }
                });
                return _context3.abrupt("return", groupedAttributes);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function FetchAndGroupAttributes() {
        return _FetchAndGroupAttributes.apply(this, arguments);
      }

      return FetchAndGroupAttributes;
    }()
  }, {
    key: "MergeAndGroupAllAttributes",
    value: function MergeAndGroupAllAttributes() {
      var _this4 = this;

      var groupedAttributes = [];

      this._allActiveAttributes.forEach(function (attribute) {
        var group = groupedAttributes.find(function (x) {
          return x.attributeTypeId === attribute.attributeTypeId;
        });

        if (group) {
          group.attributes.push({
            attributeId: attribute.attributeId,
            attributeName: attribute.attributeName,
            checked: !!_this4._userAttributes.find(function (x) {
              return x.attributeId == attribute.attributeId;
            })
          });
        } else {
          groupedAttributes.push({
            attributeTypeId: attribute.attributeTypeId,
            attributeTypeName: attribute.attributeTypeName,
            attributes: [{
              attributeId: attribute.attributeId,
              attributeName: attribute.attributeName,
              checked: !!_this4._userAttributes.find(function (x) {
                return x.attributeId == attribute.attributeId;
              })
            }]
          });
        }
      });

      return groupedAttributes;
    }
  }, {
    key: "DrawAttributesViewMode",
    value: function DrawAttributesViewMode() {
      var _this5 = this;

      this._$userAttributesEditModeContainer.style.display = "none";
      this._$userAttributesEditMode.style.display = "none";
      this._$userAttributesViewMode.style.display = "";
      this._$userAttributesViewMode.innerHTML = "";
      this._$editButton.style.display = "";

      this._userGroupedAttributes.forEach(function (category) {
        var attributesBlockContainer = document.createElement("div");
        attributesBlockContainer.className = "mpp-about-me--attributes-block"; // Category name

        var titleRow = document.createElement("div");
        titleRow.className = "mpp-about-me--attributes-block-title";
        titleRow.innerText = category.attributeTypeName;
        attributesBlockContainer.appendChild(titleRow); // Attributes list

        var attributesListContainer = document.createElement("div");
        attributesListContainer.className = "mpp-about-me--atributes-list";
        category.attributes.sort(function (a, b) {
          return a.attributeName.localeCompare(b.attributeName, undefined, {
            "sensitivity": "base"
          });
        });
        category.attributes.forEach(function (attribute) {
          var attributesListItem = document.createElement("div");
          attributesListItem.className = "mpp-about-me--attribute";
          attributesListItem.innerText = attribute.attributeName;
          attributesListContainer.appendChild(attributesListItem);
        });
        attributesBlockContainer.appendChild(attributesListContainer);

        _this5._$userAttributesViewMode.appendChild(attributesBlockContainer);
      });
    }
  }, {
    key: "DrawAttributesEditMode",
    value: function DrawAttributesEditMode() {
      var _this6 = this;

      this._$userAttributesViewMode.style.display = "none";
      this._$userAttributesEditModeContainer.style.display = "";
      this._$userAttributesEditMode.style.display = "flex";
      this._$userAttributesEditMode.innerHTML = "";
      this._$editButton.style.display = "none";
      this._$cancelButton.style.display = "";

      if (this._userAttributes.length <= 0) {
        this._$cancelButton.style.display = "none";
      }

      this._addedAttributes = [];
      this._removedAttributes = [];
      this.IsSubmitEnabled();

      this._allGroupedAttributes.forEach(function (category) {
        var attributesBlockContainer = document.createElement("div");
        attributesBlockContainer.className = "mpp-about-me--attributes-block"; // Category name

        var titleRow = document.createElement("div");
        titleRow.className = "mpp-about-me--attributes-block-title";
        titleRow.innerText = category.attributeTypeName;
        attributesBlockContainer.appendChild(titleRow); // Attributes list

        var attributesListContainer = document.createElement("div");
        attributesListContainer.className = "mpp-about-me--atributes-list";
        category.attributes.sort(function (a, b) {
          return a.attributeName.localeCompare(b.attributeName, undefined, {
            "sensitivity": "base"
          });
        });
        category.attributes.forEach(function (attribute) {
          var attributesListItem = document.createElement("div");
          attributesListItem.className = "mpp-about-me--attribute";
          var label = document.createElement("label");
          label.className = "mpp-about-me--checkbox-container";
          var input = document.createElement("input");
          input.type = "checkbox";
          input.name = "category_".concat(category.attributeTypeId, "_attribute_").concat(attribute.attributeId);
          input.checked = attribute.checked;
          input.addEventListener("click", function () {
            var userAttribute = _this6._userAttributes.find(function (x) {
              return x.attributeId === attribute.attributeId;
            });

            if (userAttribute) {
              if (input.checked) {
                _this6._removedAttributes = _this6._removedAttributes.filter(function (x) {
                  return x != attribute.attributeId;
                });
              } else {
                _this6._removedAttributes.push(attribute.attributeId);
              }
            } else {
              if (input.checked) {
                _this6._addedAttributes.push(attribute.attributeId);
              } else {
                _this6._addedAttributes = _this6._addedAttributes.filter(function (x) {
                  return x != attribute.attributeId;
                });
              }
            }

            _this6.IsSubmitEnabled();
          });
          label.appendChild(input);
          var span = document.createElement("span");
          span.innerText = attribute.attributeName;
          span.className = "mpp-about-me--label-text";
          label.appendChild(span);
          attributesListItem.appendChild(label);
          attributesListContainer.appendChild(attributesListItem);
        });
        attributesBlockContainer.appendChild(attributesListContainer);

        _this6._$userAttributesEditMode.appendChild(attributesBlockContainer);
      });
    }
  }, {
    key: "IsSubmitEnabled",
    value: function IsSubmitEnabled() {
      if (this._addedAttributes.length > 0 || this._removedAttributes.length > 0) {
        this.EnableButtons();
      } else {
        this.DisableSubmitButton();
      }
    }
  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$spinner = this._root.querySelector("#spinner");
      this._$widgetContent = this._root.querySelector("#widgetContentContainer");
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$editButton = this._root.querySelector("#editMySkills");
      this._$userAttributesViewMode = this._root.querySelector("#userAttributesViewMode");
      this._$userAttributesEditMode = this._root.querySelector("#userAttributesEditMode");
      this._$userAttributesEditModeContainer = this._root.querySelector("#userAttributesEditModeContainer");
      this._$cancelButton = this._root.querySelector("#cancelEditAttributes");
      this._$submitButton = this._root.querySelector("#submitAttributes");
      this._$closeNotificationButton = this._root.querySelector(".mpp-about-me--notification-close");
      this._$notificationContainer = this._root.querySelector(".mpp-about-me--notification-container");
      this._$notificationText = this._root.querySelector(".mpp-about-me--notification-text");
    }
  }, {
    key: "LoadLabels",
    value: function () {
      var _LoadLabels = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this7 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new I18N(MppAboutMe.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this7._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this7._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function LoadLabels() {
        return _LoadLabels.apply(this, arguments);
      }

      return LoadLabels;
    }()
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this8 = this;

      this._$editButton.addEventListener("click", function () {
        _this8._$userAttributesViewMode.style.display = "none";
        _this8._$editButton.style.display = "none";
        _this8._$userAttributesEditModeContainer.style.display = "";
        _this8._allGroupedAttributes = _this8.MergeAndGroupAllAttributes();

        _this8.DrawAttributesEditMode();
      });

      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      });

      this._$cancelButton.addEventListener("click", function () {
        _this8._$userAttributesEditModeContainer.style.display = "none";
        _this8._$editButton.style.display = "";
        _this8._$userAttributesViewMode.style.display = "";

        _this8.DrawAttributesViewMode();
      });

      this._$submitButton.addEventListener("click", function () {
        _this8.ShowSpinner();

        _this8.DisableButtons();

        var attributesToSave = JSON.stringify({
          attributesToAdd: _this8._addedAttributes,
          attributesToRemove: _this8._removedAttributes
        });
        UserService.SaveUserAttributes(attributesToSave).then(function () {
          _this8.HideSpinner();

          _this8.EnableButtons();

          _this8.DisplayAttributes();

          _this8._$notificationContainer.style.display = "";

          _this8._$notificationContainer.classList.add("mpp-about-me--notification-success");

          _this8._$notificationText.innerText = _this8._i18n.successNotification;
          setTimeout(function () {
            _this8.ResetNotification();
          }, 5000); //after 5 seconds clear the notification
        }, function (err) {
          _this8.HideSpinner();

          _this8.EnableButtons();

          _this8._$notificationContainer.classList.add("mpp-about-me--notification-fail");

          _this8._$notificationContainer.style.display = "";
          _this8._$notificationText.innerText = _this8._i18n.failNotification;
        });
      });

      this._$closeNotificationButton.addEventListener("click", function () {
        _this8.ResetNotification();
      });
    }
  }, {
    key: "ResetNotification",
    value: function ResetNotification() {
      this._$notificationContainer.style.display = "none";

      this._$notificationContainer.classList.remove("mpp-about-me--notification-fail");

      this._$notificationContainer.classList.remove("mpp-about-me--notification-success");
    }
  }, {
    key: "ShowSpinner",
    value: function ShowSpinner() {
      this._$loadingContainer.style.display = "";
    }
  }, {
    key: "HideSpinner",
    value: function HideSpinner() {
      this._$loadingContainer.style.display = "none";
    }
  }, {
    key: "DisableCancelButton",
    value: function DisableCancelButton() {
      this._$cancelButton.classList.add("mpp-about-me--disabled-button");
    }
  }, {
    key: "DisableSubmitButton",
    value: function DisableSubmitButton() {
      this._$submitButton.classList.add("mpp-about-me--disabled-button");
    }
  }, {
    key: "DisableButtons",
    value: function DisableButtons() {
      this._$cancelButton.classList.add("mpp-about-me--disabled-button");

      this._$submitButton.classList.add("mpp-about-me--disabled-button");
    }
  }, {
    key: "EnableButtons",
    value: function EnableButtons() {
      this._$cancelButton.classList.remove("mpp-about-me--disabled-button");

      this._$submitButton.classList.remove("mpp-about-me--disabled-button");
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "About Me",
        tag: "mpp-about-me",
        configurationItems: []
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return [];
    }
  }]);

  return MppAboutMe;
}(ComponentBase);
MppAboutMe.registerComponent(MppAboutMe.WidgetDetails.tag, MppAboutMe);